import { getProductBySku } from "./ProductUtils";
import { multiply } from "./NumberUtils";
import BigNumber from "bignumber.js";
import { getTranslationFunction } from "./i18nUtils";
import { addVat } from "./VatUtils";

const t = getTranslationFunction();

/**
 * It is recommended to use these utility functions though CartContextProvider, but they can be used alone for test purpose etc.
 */
export function cartAddItem(cartData, cartItem) {
  if (
    cartItem.isSample &&
    cartData.items.filter(item => item.isSample).length >= 3
  ) {
    alert(t("cart.sample_limit_exceeded"));
    return cartData;
  }

  if (cartItem.isSample) {
    const exists =
      cartData.items
        .filter(item => item.isSample === true)
        .filter(item => item.sku === cartItem.sku).length > 0;
    if (exists) {
      // dont add duplicate sample
      return cartData;
    }
  } else {
    const indexExisting = cartData.items
      .filter(item => !item.isSample)
      .findIndex(item => item.sku === cartItem.sku);
    if (indexExisting >= 0) {
      // merge amounts
      return cartItemUpdateAmount(
        cartData,
        indexExisting,
        cartData.items[indexExisting].amount + cartItem.amount
      );
    }
  }
  // add new article
  return {
    ...cartData,
    items: [...cartData.items, { ...cartItem }]
  };
}

export function cartItemUpdateAmount(cartData, index, amount) {
  return {
    ...cartData,
    items: [
      ...cartData.items.slice(0, index),
      { ...cartData.items[index], amount },
      ...cartData.items.slice(index + 1)
    ]
  };
}

export function cartItemRemove(cartData, index) {
  return {
    ...cartData,
    items: [
      ...cartData.items.slice(0, index),
      ...cartData.items.slice(index + 1)
    ]
  };
}

export function cartSetItems(cartData, items) {
  return { ...cartData, items: [...items] };
}

export function cartEmpty(cartData) {
  return { ...cartData, items: [] };
}

export function cartItemCount(cartData) {
  return cartData.items.length;
}

export function cartHasItems(cartData) {
  return cartItemCount(cartData) > 0;
}

export function findCartItem(cartData, sku) {
  return cartData.items.find(item => !item.isSample && sku === item.sku);
}

export function cartItem({ name, sku, images }) {
  return {
    name,
    sku,
    image: images && images[0].styles.medium,
    isSample: false
  };
}

export function sampleCartItem({ name, sku, sampleSku, images }) {
  return {
    amount: 1,
    name,
    sku: sampleSku,
    realSku: sku,
    image: images && images[0].styles.medium,
    isSample: true
  };
}

export function cartBaseTotal(cartData, products) {
  return cartData.items
    .filter(item => !item.isSample)
    .reduce((accumulator, item) => {
      const product = getProductBySku(products, item.sku);
      if (product === undefined) return accumulator;
      const basePrice = (product.price && product.price.basePrice) || 0;
      const amount = item.amount;
      return basePrice && amount
        ? accumulator.plus(new BigNumber(multiply(amount, basePrice)))
        : accumulator;
    }, new BigNumber(0))
    .toNumber();
}

export function cartTotal(cartData, products) {
  return addVat(cartBaseTotal(cartData, products));
}

export function sortByIsSample(a, b) {
  if (a.isSample) return 1;
  if (b.isSample) return -1;
  return 0;
}
